var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrade8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#4695FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 90.7444C72.5026 90.7444 90.7445 72.5024 90.7445 49.9999C90.7445 27.4974 72.5026 9.25543 50 9.25543C27.4975 9.25543 9.25555 27.4974 9.25555 49.9999C9.25555 72.5024 27.4975 90.7444 50 90.7444Z",
    fill: "#EAEAEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2918 49.9999C15.2918 28.5126 31.9252 10.9114 53.0181 9.3669C52.0215 9.29386 51.0153 9.25543 50 9.25543C27.4974 9.25543 9.25555 27.4973 9.25555 49.9999C9.25555 72.5025 27.4974 90.7444 50 90.7444C51.0153 90.7444 52.0215 90.7059 53.0181 90.6329C31.9252 89.0884 15.2918 71.4872 15.2918 49.9999Z",
    fill: "#D8D8DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0634 31.8068C73.1402 28.5873 69.6648 26.6151 65.9123 26.6151H56.0233L50 35.0718L62.0467 42.6764L70.895 46.5853L81.5557 42.6764L75.0634 31.8068Z",
    fill: "#4695FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9767 26.6151H34.0877C30.3352 26.6151 26.8598 28.5873 24.9366 31.8068L18.4443 42.6764L30.5974 46.5853L37.9533 42.6764L50 35.0718L43.9767 26.6151Z",
    fill: "#4695FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9533 42.6765H18.4443L45.2304 76.7033C46.4457 78.2469 48.2217 79.0187 50 79.0187V57.2461L37.9533 42.6765Z",
    fill: "#76E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0467 42.6765L50 57.2461V79.0187C51.7783 79.0187 53.5543 78.2469 54.7696 76.7033L81.5557 42.6765H62.0467Z",
    fill: "#76E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0233 26.6151H43.9766L37.9533 42.6764L50 45.1682L62.0467 42.6764L56.0233 26.6151Z",
    fill: "#76E7E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0467 42.6765L50 79.0187L37.9533 42.6765H62.0467Z",
    fill: "#4695FD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade8);
export default __webpack_public_path__ + "static/media/grade8.7f19a2f0.svg";
export { ForwardRef as ReactComponent };